<template>
 <NavComponents />
  
  <div class="container">
    <el-button icon="Search" style="float: right; margin: 5px;" @click="searchCertifica()" circle />

    <input
    class="input-field"
    type="search"
    placeholder="证书编号"
    id="applyId"
    style="float: right;"
    />


    <div class="border certifica" >
        <div v-if="certificaLink == -1" class="certificaContent">
            <img src="@/assets/img/card/selectFail.png" style="width:20px">
            <span class="font_1">暂无该证书信息哦!</span>
        </div>
        <div v-if="certificaLink == 0" class="certificaContent">
            <img src="@/assets/img/card/selectCertifica.png" style="width:40px">
            <span class="font_1">请输入整数编号!</span>
        </div>
        <div v-if="certificaLink != 0 && certificaLink != -1" @click="download(certificaLink)" class="certificaContent">
            <img :src="certificaLink" class="certificaImg">
        </div>
    </div>

   

  </div>
  <NavFooter/>
</template>
  
  <script setup>
import NavComponents from "@/components/nav/NavComponents.vue";
import NavFooter from '@/components/nav/NavFooter.vue'
import { ElMessage } from "element-plus";
import $ from "jquery";

import { ref } from 'vue'
const certificaLink = ref(0);
const token = localStorage.getItem("token");

const searchCertifica = () => {
    let applyId = $("#applyId").val();
    if (applyId == null || applyId == "") {
        ElMessage({
            type: "error",
            message: "请输入整数编号!"
        });
        return false;
    }

    $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/getCertificaLink",
        data: {
            applyId: applyId,
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg
                });
                if (resp.data == null || resp.data == "") certificaLink.value = -1;
                else certificaLink.value = resp.data;
            } else {
                ElMessage({
                    type: "error",
                    message: resp.msg
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "服务器异常!请稍后再试!"
            });
        },
    });
    }


    const download = (link) => {
  const element = document.createElement('a');
  element.setAttribute('href', link);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}
  
</script>

<style scoped>
.input-field {
    width: 300px; /* 输入框宽度 */
    padding: 5px;
    border: 1px solid #ccc; /* 边框样式 */
    border-radius: 5px; /* 边框圆角 */
    font-size: 16px; /* 字体大小 */
    outline: none; /* 去除默认轮廓 */
}
.input-field:hover,
.input-field:focus {
    border-color: #66afe9; /* 修改边框颜色 */
    box-shadow: 0 0 5px rgba(102, 175, 233, 0.6); /* 添加阴影效果 */
}

.certifica {
    width: 900px;
    height: 500px;
}

.font_1 {
    font-size: 20px;
    color: #5f5f5f;
}
.certifica {
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
}

.certificaImg {
    width: 750px;
    height: 400px;
    transition: 300ms;
}
.certificaImg:hover{
    width: 800px;
    height: 430px;
    cursor: pointer;
    transition: 300ms;
}
</style>
